import UibookCase from 'uibook/case'
import Popup from '../Popup'
import React from 'react'

const I18N = {
  ru: {
    title: 'Ошибка',
    autoHeight: 'Автоматическая высота',
    fixedHeight: 'Фиксированная высота',
    text: 'Вы не можете добавить проект к этому биллинг-аккаунту, потому что не являетесь его администратором.'
  },
  en: {
    title: 'Error',
    autoHeight: 'Auto height',
    fixedHeight: 'Fixed height',
    text: 'You can’t add a project to this billing account because you’re not a billing admin of the account.'
  }
}

export default {
  background: 'dark',
  component: Popup,
  i18n: true,
  cases: [
    locale => <UibookCase props={{
      title: I18N[locale].title,
      text: I18N[locale].text
    }}></UibookCase>,
    {
      width: 150,
      body: locale => <Popup
        title={ I18N[locale].autoHeight }
        text={ I18N[locale].text }
      ></Popup>,
    },
    {
      height: 150,
      body: locale => <Popup
        title={ I18N[locale].fixedHeight }
        text={ I18N[locale].text }
      ></Popup>,
    }
  ]
}
